import React from 'react';
import { connect } from 'react-redux';
import {
  mapStateToProps,
} from '../components/QueryFilterContainer';
import QueryFilterFieldEditCell from '../components/QueryFilterFieldEditCell';
import { addQueryFilter } from '../actions';

const QueryFilterFieldAddCell = ({
  code,
  category,
  dictionary,
  fieldName,
  clauseUUID,
  exists,
  canRead,
  canEdit,
  addFilter,
  queryUUID,
}) => (
  <QueryFilterFieldEditCell
    exists={exists}
    canRead={canRead}
    canEdit={canEdit}
    onChange={(value) => addFilter(category, code, queryUUID, clauseUUID, value)}
    fields={dictionary.fields}
    fieldName={fieldName}
    queryUUID={queryUUID}
  />
);

export const mapDispatchToProps = {
  addFilter: addQueryFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryFilterFieldAddCell);
